import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "q-row" }
const _hoisted_2 = {
  key: 0,
  class: "popular-products__header q-col-lg-12 q-text-muted q-fw-semibold"
}

import SingleProduct from './SingleProduct.vue';
import CustomLink from './CustomLink.vue'; // Dodaj import nowego komponentu

import { inject, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useMobileViewStore } from '@/store/MobileViewStore';
import { SmartSearchConfigInterface } from '@/core/types';

// Definicja props

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductsList',
  props: ['productsList', 'productsHeader', 'promotedProductEnabled', 'canShowPromotedSection'],
  setup(__props) {



// Pobieramy customTemplate z konfiguracji (np. autocompleteSingleResult)
const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!)
const customTemplate = SmartSearchConfig?.value?.serp?.customComponents?.autocompleteSingleResult;

const mobileViewStore = useMobileViewStore();
const { isMobileView } = storeToRefs(mobileViewStore);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["q-col-12", {'q-col-12 q-col-lg-12 q-col-xl-9 q-ps-1': __props.promotedProductEnabled && __props.canShowPromotedSection, 'q-col-12': !__props.promotedProductEnabled && !__props.canShowPromotedSection}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_unref(isMobileView) && __props.productsList.length > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.productsHeader), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.productsList, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.id || item.url
        }, [
          (item.type !== 'custom')
            ? (_openBlock(), _createBlock(SingleProduct, {
                key: 0,
                result: item,
                customTemplate: _unref(customTemplate)
              }, null, 8, ["result", "customTemplate"]))
            : (_openBlock(), _createBlock(CustomLink, {
                key: 1,
                url: item.url,
                label: item.label
              }, null, 8, ["url", "label"]))
        ], 64))
      }), 128))
    ])
  ], 2))
}
}

})